'use client';

import Link from 'next/link';
import { ReactNode, useCallback } from 'react';

interface ShibLinkProps {
  href?: any; // todo
  children?: ReactNode;
  className?: string;
  scroll?: boolean;
  target?: string;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void; // Add onClick prop
}

const ShibLink = ({ href, children, className, scroll, target, onClick }: ShibLinkProps) => {
  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      if ((href as string).startsWith('#')) {
        const destination = document?.querySelector(href as string);
        if (destination) {
          destination.scrollIntoView({
            behavior: 'smooth',
          });
        }
        e.preventDefault();
      }
      if (onClick) {
        onClick(e); // Call the onClick prop if provided
      }
    },
    [href, onClick]
  );

  return (
    <Link
      href={href}
      onClick={handleClick}
      onKeyDown={(e) => handleClick(e as unknown as React.MouseEvent<HTMLAnchorElement>)}
      scroll={scroll}
      target={target}
      className={`block rounded py-2 text-[1em] text-white ${className}`}
    >
      {children}
    </Link>
  );
};

export default ShibLink;